/* eslint-disable max-len */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';

export default class ConditionNode extends BaseNode {
    operator: string;

    constructor() {
        super();
        this.linkedFeature = 'general';
        this.name = 'IF Condition (Advanced)';
        this.icon = 'TbArrowsSplit2';
        this.id = 'node_condition';

        const settings: Setting[] = [
            {
                id: 'CODE',
                name: 'Code',
                settingType: SettingType.CODE,
                required: true,
                default: '1=1',
            },
        ];

        this.inputs = [
            {
                name: 'Condition',
                portId: 'cond',
                params: [],
            },
        ];

        this.outputs = [
            {
                name: 'True',
                portId: 'true_output',
                params: [],
            },
            {
                name: 'False',
                portId: 'false_output',
                params: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const CODE = this.getSettingValue('CODE');
            return `if ${CODE}`;
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const CODE = this.getSettingValue('CODE');
        return `if ${CODE}`;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `#### Condition (Advanced)
Similar to the Condtion block, this block can be used to combine multiple conditions 

e.g. 
\`\`\`
    A > 1 AND A < 5
\`\`\`
`;
    }
}
